import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ThemeModeState } from './theme-mode.state';

const selectThemeState = createFeatureSelector<ThemeModeState>('theme');

export const selectIsDarkMode = createSelector(
  selectThemeState,
  (state) => state.mode
);
